export default "__VITE_ASSET__DrDV8y_$__"